import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { marcarOnboardingCompleto } from '../../actions/auth';
import { types } from '../../types/types';

const WA_NUMERO = process.env.REACT_APP_WA_NUMERO_COMPARTIDO || '527714709601';
const REVI_STRIPE_API = process.env.REACT_APP_STRIPE_API_URL || 'https://revi-stripe-service-717967703066.us-central1.run.app';

export const PasoListo = () => {
    const dispatch = useDispatch();
    const { hashtag, nombre } = useSelector(state => state.auth);
    const [toast, setToast] = useState(false);
    const [procesando, setProcesando] = useState(false);
    const [error, setError] = useState(null);

    const msg = encodeURIComponent(`Quiero reservar con ${hashtag}`);
    const link = `https://wa.me/${WA_NUMERO}?text=${msg}`;
    const linkMostrar = `wa.me/${WA_NUMERO}?text=Quiero reservar con ${hashtag}`;

    const copiarLink = () => {
        if (navigator.clipboard) navigator.clipboard.writeText(link).catch(() => {});
        setToast(true);
        setTimeout(() => setToast(false), 2500);
    };

    const compartirLink = () => {
        if (navigator.share) {
            navigator.share({ title: `Reserva en ${nombre}`, text: 'Reserva tu cita aquí:', url: link });
        } else {
            copiarLink();
        }
    };

    const irAMiNegocio = async () => {
        setProcesando(true);
        setError(null);

        try {
            // Recuperar el session_id de la URL (Stripe lo mandó al redirigir)
            const params = new URLSearchParams(window.location.search);
            const sessionId = params.get('session_id');

            // Si hay session_id, verificar la suscripción con Stripe directo
            // (no dependemos del webhook para dejar pasar a la clienta)
            if (sessionId) {
                const res = await fetch(`${REVI_STRIPE_API}/stripe/verificar-sesion`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ sessionId, hashtag })
                });
                const data = await res.json();

                if (data.activa) {
                    // Actualizar Redux para que AppRouter vea suscripcionActiva: true
                    dispatch({
                        type: types.authUpdateEmpresa,
                        payload: { suscripcionActiva: true }
                    });
                }
            }

            // Marcar onboarding completo
            await dispatch(marcarOnboardingCompleto());

        } catch (e) {
            setError('Hubo un problema al confirmar tu suscripción. Intenta de nuevo.');
            setProcesando(false);
        }
    };

    return (
        <div className="app-container" style={{ position: 'relative' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '32px 24px' }}>
                <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'var(--pink-100)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 34, marginBottom: 16 }}>
                    🎉
                </div>
                <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--pink-900)', marginBottom: 8, textAlign: 'center' }}>
                    ¡Tu negocio está listo!
                </h1>
                <p style={{ fontSize: 14, color: 'var(--pink-800)', lineHeight: 1.7, marginBottom: 20, textAlign: 'center' }}>
                    Ya puedes recibir citas por WhatsApp. Comparte tu link y el bot hará el resto.
                </p>

                {/* Link de reservas */}
                <div style={{ background: 'var(--pink-50)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 16, width: '100%', marginBottom: 14 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--pink-900)', marginBottom: 8 }}>🔗 Tu link de reservas</div>
                    <div className="link-box" style={{ marginTop: 0 }}>
                        <div className="link-text">{linkMostrar}</div>
                        <button className="copy-btn" onClick={copiarLink}>Copiar</button>
                    </div>
                    <div className="action-grid" style={{ marginTop: 10 }}>
                        <div className="action-btn" onClick={compartirLink}>📤 Compartir</div>
                        <a href={link} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                            <div className="action-btn">👁️ Probarlo</div>
                        </a>
                    </div>
                </div>

                <div className="info-box" style={{ width: '100%', marginBottom: 20 }}>
                    <div className="info-box-title">✅ Lo que configuraste:</div>
                    <div className="info-box-body">
                        ✓ Nombre y dirección del negocio<br />
                        ✓ Servicios con precios<br />
                        ✓ Colaboradoras con calendario<br />
                        ✓ Servicios asignados por colaboradora
                    </div>
                </div>

                {error && (
                    <div style={{ background: '#fff0f0', border: '0.5px solid #ffcccc', borderRadius: 8, padding: 12, width: '100%', marginBottom: 16, fontSize: 13, color: '#cc0000', textAlign: 'center' }}>
                        {error}
                    </div>
                )}

                <button
                    className="btn-primary"
                    style={{ width: '100%' }}
                    onClick={irAMiNegocio}
                    disabled={procesando}
                >
                    {procesando ? 'Confirmando...' : 'Ir a mi negocio →'}
                </button>
            </div>

            {toast && <div className="toast visible">¡Link copiado!</div>}
        </div>
    );
};